import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link, fetchUtils } from 'react-admin';
import LinkField from './LinkField';
import DefaultMapper from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class EnhancedLinkField extends Component {

	state = {}

	async componentDidMount() {
		const { record, source } = this.props;
		const value = get(record, source);
		if (value === null || typeof value !== 'object') {
			return;
		}
		const type = get(value, 'type');
		const id = get(value, 'id');
		const mapping = LinkField.defaultProps.mappingDictionary[type];
		let idToUse = id;
		let label = `${type} ${idToUse}`;
		if (type === 'Account') {
			try {
				const { json: { data: result } } = await fetchUtils.fetchJson(`${API_BASE_PATH_ADMIN}/system/config/idutil/ids/${type}?publicId=${id}`, {
					...DefaultMapper.createOptions(),
					method: 'GET'
				});
				idToUse = result.internalId;
				label = `${type} ${id} (${idToUse})`
			} catch (_) {
				// ignore, use default
			}
		}
		this.setState({
			link: `/${mapping}/${idToUse}/show`,
			label
		});
	}

	render() {
		const { link, label } = this.state;
		return link ? <Link to={link}>{label}</Link> : null;
	}

};
EnhancedLinkField.propTypes = {
	record: PropTypes.object,
	source: PropTypes.string.isRequired
};
EnhancedLinkField.defaultProps = {
	addLabel: true
};

export default EnhancedLinkField;
